(function () {
  function syncVariantFromOptions(form) {
    var optionSelects = form.querySelectorAll('[data-io-option-select]');
    var variantSelect = form.querySelector('[data-io-variant-select]');
    if (!optionSelects.length || !variantSelect || variantSelect.tagName !== 'SELECT') return;

    var sizeSel = form.querySelector('[data-io-size-select]');
    var colorSel = null;
    optionSelects.forEach(function (sel) {
      var name = (sel.getAttribute('data-io-option-name') || '').toLowerCase();
      if (name === 'color' || name === 'colour') colorSel = sel;
    });

    function currentOptions() {
      var vals = ['', '', ''];
      optionSelects.forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-option-position'), 10) || 1;
        vals[pos - 1] = sel.value;
      });
      return vals;
    }

    function refreshSizeAvailability() {
      if (!sizeSel || !colorSel) return;
      var colorVal = colorSel.value;
      var colorPos = parseInt(colorSel.getAttribute('data-option-position'), 10) || 1;
      var sizePos = parseInt(sizeSel.getAttribute('data-option-position'), 10) || 2;
      var options = Array.prototype.slice.call(variantSelect.options).filter(function (o) { return !!o.value; });
      Array.prototype.forEach.call(sizeSel.options, function (sizeOpt) {
        if (!sizeOpt.value) return; // placeholder
        var available = options.some(function (opt) {
          if (opt.getAttribute('data-available') === 'false' || opt.disabled) return false;
          var oColor = opt.getAttribute('data-option' + colorPos) || '';
          var oSize = opt.getAttribute('data-option' + sizePos) || '';
          return oColor === colorVal && oSize === sizeOpt.value;
        });
        sizeOpt.disabled = !available;
        if (!available) sizeOpt.setAttribute('data-sold-out', '1');
        else sizeOpt.removeAttribute('data-sold-out');
      });
      // If current size became sold out, reset to placeholder
      if (sizeSel.value && sizeSel.selectedOptions[0] && sizeSel.selectedOptions[0].disabled) {
        sizeSel.value = '';
      }
    }

    function matchVariant() {
      refreshSizeAvailability();
      var vals = currentOptions();
      var atc = form.querySelector('#io-atc-btn');
      if (sizeSel && !sizeSel.value) {
        if (atc && atc.getAttribute('data-io-deco-locked') !== '1') {
          atc.disabled = true;
          atc.setAttribute('aria-disabled', 'true');
        }
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var options = Array.prototype.slice.call(variantSelect.options);
      var found = options.find(function (opt) {
        if (!opt.value) return false;
        var o1 = opt.getAttribute('data-option1') || '';
        var o2 = opt.getAttribute('data-option2') || '';
        var o3 = opt.getAttribute('data-option3') || '';
        return o1 === vals[0] && o2 === vals[1] && o3 === vals[2];
      });
      if (!found) return;
      variantSelect.value = found.value;
      // Keep disabled state in sync for sold-out matches
      if (found.disabled || found.getAttribute('data-available') === 'false') {
        // leave selected so price can show, but purchase blocked via variantReady
      }
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      if (atc && atc.getAttribute('data-io-deco-locked') !== '1') {
        var sold = found.disabled || found.getAttribute('data-available') === 'false';
        atc.disabled = !!sold;
        if (!sold) {
          atc.removeAttribute('disabled');
          atc.removeAttribute('aria-disabled');
        } else {
          atc.setAttribute('aria-disabled', 'true');
        }
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', matchVariant);
    });
    matchVariant();
  }

  // Also sync price for single variant dropdown products
  function bindSingleVariantPrice(form) {
    var sel = form.querySelector('select[data-io-variant-select]:not([hidden])');
    if (!sel) return;
    sel.addEventListener('change', function () {
      // sticky script also listens; ensure event fires
    });
  }

  function boot() {
    document.querySelectorAll('form.io-product-form').forEach(function (form) {
      syncVariantFromOptions(form);
      bindSingleVariantPrice(form);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
